import { lessonCardExamplePng } from '../assets/images';
import { SITE_LINKS } from '../constants';
import { LessonCardProps, LessonCardStatus } from '../stories/LessonCard';

export interface UnitPageData {
  thumbSrc: null;
  type: string;
  status: string;
  name: string;
  position: number;
  description: string;
  description_es: string;
  'description_pt-BR': string;
  lessons: UnitPageLesson[];
  levelPosition: number;
}

export interface UnitPageLesson {
  position: number;
  name: string;
  status: UnitPageLessonStatus;
  image: string; // the image source url
  activity: string; // the activity url
  playerUrl: string | null;
  playerLessonId: string | null;
  unitPosition: number | null;
  levelPosition: number | null;
}

type UnitPageLessonStatus = 'pending' | 'in_progress' | 'completed';

interface UnitPageLessonWithUnitData extends UnitPageLesson {
  levelName: string;
  buttonText: string;
  levelPosition: number;
  unitPosition: number;
}

export const getLessonCardProps = (lesson: UnitPageLessonWithUnitData): LessonCardProps => {
  return {
    buttonText: lesson.buttonText,
    imgSrc: lesson.image || lessonCardExamplePng,
    href: SITE_LINKS.LessonPage(lesson.levelPosition, lesson.unitPosition, lesson.position),
    status: getLessonCardStatus(lesson.status),
    subtitle: lesson.levelName,
    title: lesson.name,
    type: 'lesson',
    position: lesson.position,
  };
};

const getLessonCardStatus = (status: UnitPageLessonStatus): LessonCardStatus => {
  switch (status) {
    case 'completed':
      return 'done';
    case 'in_progress':
      return 'current';
    case 'pending':
    default:
      return 'blocked';
  }
};
